import { batch, useDispatch } from 'react-redux'
import { reset as dashboardCommonReset } from 'features/dashboard/dashboardCommonSlice'
import { reset as dashboardFilterReset } from 'features/dashboard/filter/dashboardFilterSlice'
import { reset as tableColumnsReset } from 'features/dashboard/table/config/tableConfigSlice'
import { reset as campaignTableReset } from 'features/dashboard/table/campaign/campaignTableSlice'
import { reset as adGroupTableReset } from 'features/dashboard/table/adGroup/adGroupTableSlice'
import { reset as keywordTableReset } from 'features/dashboard/table/keyword/keywordTableSlice'
import { reset as creativeTableReset } from 'features/dashboard/table/creative/creativeTableSlice'
import { reset as dashboardTreeReset } from 'features/dashboard/tree/dashboardTreeSlice'
import { reset as dashboardInfoReset } from 'features/dashboard/info/dashboardInfoSlice'
import { reset as dashboardChartReset } from 'features/dashboard/info/chart/dashboardChartSlice'

import { useEffect } from 'react'
import usePrevious from './usePrevious'
import { getPathAdAccountId } from '../index'

export const useDashboardReset = () => {
  const dispatch = useDispatch()
  const id = getPathAdAccountId()
  const previousId = usePrevious(id)
  useEffect(() => {
    if (previousId && previousId !== id) {
      batch(() => {
        dispatch(dashboardCommonReset())
        dispatch(dashboardFilterReset())
        dispatch(tableColumnsReset())
        dispatch(campaignTableReset())
        dispatch(adGroupTableReset())
        dispatch(keywordTableReset())
        dispatch(creativeTableReset())
        dispatch(dashboardTreeReset())
        dispatch(dashboardInfoReset())
        dispatch(dashboardChartReset())
      })
    }
  }, [dispatch, previousId, id])
}
